import * as types from './LoginActionType';

export const loginRequest = data => ({
    type: types.LOGIN_REQUEST,
    payload: data,
});
export const loginSuccess = data => ({
    type: types.LOGIN_SUCCESS,
    payload: data,
});
export const loginFailure = data => ({
    type: types.LOGIN_FAILURE,
    payload: data,
});

export const logoutRequest = data => ({
    type: types.LOGOUT_REQUEST,
    payload: data,
});
export const logoutSuccess = data => ({
    type: types.LOGOUT_SUCCESS,
    payload: data,
});
export const logoutFailure = data => ({
    type: types.LOGOUT_FAILURE,
    payload: data,
});

export const resetPasswordRequest = (data) => ({
  type: types.RESET_PASSWORD_REQUEST,
  payload: data,
});

export const resetPasswordSuccess = (data) => ({
  type: types.RESET_PASSWORD_SUCCESS,
  payload: data,
});

export const resetPasswordFailure = (error) => ({
  type: types.RESET_PASSWORD_FAILURE,
  payload: error,
});

export const forgetPasswordRequest = (data) => ({
  type: types.FORGET_PASSWORD_REQUEST,
  payload: data,
});

export const forgetPasswordSuccess = (data) => ({
  type: types.FORGET_PASSWORD_SUCCESS,
  payload: data,
});

export const forgetPasswordFailure = (error) => ({
  type: types.FORGET_PASSWORD_FAILURE,
  payload: error,
});

export const forgetPasswordResetRequest = (data) => ({
  type: types.FORGET_PASSWORD_RESET_REQUEST,
  payload: data,
});

export const forgetPasswordResetSuccess = (data) => ({
  type: types.FORGET_PASSWORD_RESET_SUCCESS,
  payload: data,
});

export const forgetPasswordResetFailure = (error) => ({
  type: types.FORGET_PASSWORD_RESET_FAILURE,
  payload: error,
});

// MFA actions
export const verifyMfaRequest = (data) => ({
  type: types.VERIFY_MFA_REQUEST,
  payload: data,
});

export const verifyMfaSuccess = (data) => ({
  type: types.VERIFY_MFA_SUCCESS,
  payload: data,
});

export const verifyMfaFailure = (error) => ({
  type: types.VERIFY_MFA_FAILURE,
  payload: error,
});